import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { MdClose } from "react-icons/md";
import FileImage from "../../images/file.svg";
import UploadImage from "../../images/upload.svg";
import { Button } from "../Button";
import { ProgressBar } from "../ProgressBar";
import "./styles.scss";

interface DropzoneFilesProps {
  setFile: (file: any) => void;
}

function DropzoneFiles({ setFile }: DropzoneFilesProps) {
  const [progressUpload, setProgressUpload] = useState(0);
  const [isUploaded, setIsUploaded] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    try {
      const fileReader = new FileReader();
      const file = acceptedFiles[0];

      if (file) {
        fileReader.readAsDataURL(file);

        setFilename(file.name);

        fileReader.onloadstart = () => {};

        fileReader.onprogress = (ev) => {
          setProgressUpload((100 * ev.loaded) / file.size);
        };

        fileReader.onloadend = () => {
          setFile(file);
          setIsUploaded(true);
        };
      } else {
        console.log("nenhum arquivo encontrado");
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxSize: 5242880,
    maxFiles: 1,
    accept: ["application/pdf", "image/png", "image/jpg"],
  });

  const [filename, setFilename] = useState("");

  function removeUpload() {
    setFilename("");
    setFile(undefined);
  }

  return (
    <div
      {...getRootProps()}
      className={`dropzoneFiles ${isUploaded ? "uploaded" : ""}`}
    >
      <input {...getInputProps()} />
      {isDragActive && !filename && <p>Solte seu arquivo aqui...</p>}

      {!isDragActive && !filename && (
        <>
          <img src={UploadImage} alt="Upload Icon" />
          <p>Arraste e solte seu arquivo aqui</p>
          <p>OU</p>
          <button className="button" type="button">Envie do seu computador</button>
          <span>PDF, JPG e PNG, Tamanho máximo de 5MB</span>
        </>
      )}

      {filename && (
        <div className="uploadedFileContainer">
          <img src={FileImage} alt="Uploaded File" />
          <div className="uploadInfoContainer">
            <div className="uploadInfo">
              <span>{filename}</span>
              <span>{`${Math.ceil(progressUpload)}%`}</span>
            </div>

            <ProgressBar progress={progressUpload} />
          </div>
          <button onClick={removeUpload}>
            <MdClose color="#005737" size={24} />
          </button>
        </div>
      )}
    </div>
  );
}

export { DropzoneFiles };
